import api from "./api";

// "View as" role preview endpoints (TP-View-As). All superuser-gated and
// flag-gated on the backend — a 403/404 here is the real gate, the frontend
// flag only hides the UI. Kept in its own module (not api.js) so the shared
// service file stays untouched beyond the is_superuser threading.
const impersonationService = {
  // Mints a short-lived, target-scoped token pair + login-shaped user
  // payload for the selected account. Response: { success, user, tokens,
  // audit_id }.
  start: async (accountId) => {
    const response = await api.post("/users/impersonation/start/", {
      account_id: accountId,
    });
    return response.data;
  },

  // Runs under the TARGET's JWT (the imp claim identifies the superuser).
  // Closes the audit row and revokes the preview refresh token server-side.
  exit: async () => {
    const response = await api.post("/users/impersonation/exit/");
    return response.data;
  },

  // Searches ALL accounts by email (USERNAME_FIELD) as well as name.
  // Returns normalized picker rows.
  searchUsers: async (q, limit = 20) => {
    const response = await api.get("/users/impersonation/search/", {
      params: { q, limit },
    });
    const rows = response?.data?.results || [];
    return rows.map((row) => ({
      account_id: row.account_id,
      email: row.email || "",
      name: row.name || row.email || "",
      role_label: row.role_label || "",
      org_label: row.org_label || "",
      avatar_url: row.avatar_url || null,
    }));
  },
};

export default impersonationService;
